/**
 * Block-level change detection for the Read view's 30-day highlights and
 * the Discuss live pane's just-updated flash. Markdown is split on blank
 * lines; a block counts as changed when its trimmed text doesn't appear in
 * the baseline — cheap, and precise enough for paragraph-level highlighting.
 */

export function splitBlocks(markdown: string): string[] {
  return markdown.split(/\n{2,}/).filter((b) => b.trim().length > 0);
}

export function changedBlockIndices(baseline: string, current: string): Set<number> {
  const before = new Set(splitBlocks(baseline).map((b) => b.trim()));
  const changed = new Set<number>();
  splitBlocks(current).forEach((block, i) => {
    if (!before.has(block.trim())) changed.add(i);
  });
  return changed;
}

export interface TocItem {
  text: string;
  level: 2 | 3;
}

export function extractToc(markdown: string): TocItem[] {
  const items: TocItem[] = [];
  let inCode = false;
  for (const line of markdown.split('\n')) {
    if (/^\s*```/.test(line)) inCode = !inCode;
    if (inCode) continue;
    const m = /^(#{2,3})\s+(.+)$/.exec(line);
    if (m) items.push({ level: m[1].length as 2 | 3, text: m[2].replace(/[*_`]/g, '').trim() });
  }
  return items;
}
